import React from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '../../shared/buttons/Button';

const CalendarViewControl = ({ onView, view }) => (
  <div className="flex col-span-1 justify-start items-center">
    <Button
      onClick={() => onView('month')}
      variant="toolbar"
      className={twMerge('rounded-r-none border-r-0', view === 'month' && 'bg-gray-100')}
    >
      Місяць
    </Button>
    <Button
      onClick={() => onView('week')}
      variant="toolbar"
      className={twMerge('rounded-none', view === 'week' && 'bg-gray-100')}
    >
      Тиждень
    </Button>
    <Button
      onClick={() => onView('day')}
      variant="toolbar"
      className={twMerge('rounded-l-none border-l-0', view === 'day' && 'bg-gray-100')}
    >
      День
    </Button>
  </div>
);

export default CalendarViewControl;
